var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.369,
    height: 62.403,
    viewBox: "0 0 62.369 62.403",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(-440.815 -52.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(452 63.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(82.019 -243.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "complete-ok-accept-good-tick-svgrepo-com_1_",
    "data-name": "complete-ok-accept-good-tick-svgrepo-com (1)",
    transform: "translate(357.958 295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M28.46,42.29A2,2,0,0,1,27,41.71l-9.5-9.5a2,2,0,0,1,2.83-2.83l8.09,8.09L43.63,22.29a2,2,0,1,1,2.83,2.83L29.87,41.71A2,2,0,0,1,28.46,42.29Z",
    fill: "#28a745"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(45.075 -193.536) rotate(-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "complete-ok-accept-good-tick-svgrepo-com_1_2",
    "data-name": "complete-ok-accept-good-tick-svgrepo-com (1)",
    transform: "translate(357.958 295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M32,60A28,28,0,1,1,60,30.47a2,2,0,1,1-4,.22,24.092,24.092,0,1,0-2.42,11.82,2,2,0,1,1,3.59,1.75A27.78,27.78,0,0,1,40.91,58.55,28.14,28.14,0,0,1,32,60Z",
    fill: "#28a745"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.e56d58d2ee6c6aaf979b522fe918ca1b.svg";
export { ForwardRef as ReactComponent };